import React from 'react';

interface HyperlinkSummaryProps {
  text: string;
}

const HyperlinkSummary: React.FC<HyperlinkSummaryProps> = ({ text }) => {
  const jiraUrlRegex = /https:\/\/sortup\.atlassian\.net\/browse\/([A-Za-z0-9]+-\d+)\s*(\d+\.?\d*H)?/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;

  while ((match = jiraUrlRegex.exec(text)) !== null) {
    const startIndex = match.index;
    const endIndex = jiraUrlRegex.lastIndex;
    const fullUrl = match[0];
    const ticketId = match[1];
    const hours = match[2] || ''; 

    // Add preceding text if exists
    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex));
    }

   
    parts.push(
      <div
        key={`${ticketId}-${startIndex}`}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "8px", 
          margin: "8px 0", 
        }}
      >
        <a
          href={fullUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {ticketId}
        </a>
        {hours && (
          <span style={{ fontWeight: "normal", color: "#666" }}>{hours}</span>
        )}
      </div>
    );

    lastIndex = endIndex;
  }

  // Add remaining text after last match
  if (lastIndex < text?.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts}</>;
};

export default HyperlinkSummary;
